import React, { Component } from 'react';

import {
  Page, Card, Layout,SkeletonBodyText,Button,Pagination,Toast,Tabs,Filters,SkeletonPage,IndexTable,Select, Thumbnail, Modal,
  FormLayout,TextField, BlockStack,Tooltip
  // Stack,TextStyle,ChoiceList,
} from "@shopify/polaris";
import utils from '../../../../utils/utils'
import {
  // PlusMinor,
  // CirclePlusMajor
} from '@shopify/polaris-icons';

import { 
  reqGetInventoryList,reqPostRemoveInventory
} from '../../../../api';

import AddInventoryModal from './AddInventoryModal';
import _ from "lodash";
import '../index.css';
import intl from '../../../../i18n/intl';
import AppBridge from '../../../../utils/appBridge';

class CustomPackagingClass extends Component {

  state = {
    //页面动作
    loadingPage: false,
    isSearching: false,
    page: 1,
    size: 50,
    hasPrevious: false,
    hasNext: true,
    ShowCountNumber: 0,

    tabSelected: 0,
    queryValue: '',  // 关键词内容搜索
    sortBy: '',

    filterStatus: 'Inventory quantity',  // 库存搜索
    expressionSelect: 'equal to',
    filterValue: '',
    filterIsSearch: false,

    EffectiveCount: 0,
    BulkButtonLoading: false,
    BulkOperationTipsActive: false,
    isBulkOperationsRequest: false,
    
    // 列表原始数据
    pageData: [],

    moreDataSwitch: false,   // 开关，是否允许开启更多数据选择
    isAllowSelectAllItems: false,  // 是否选择更多的数据 (未显示的)
    allResourcesSelected: false,  // (当前页面,并且包括未显示的) 全选
    selectedResources: [],

    // 增加库存弹窗
    AddInventoryOrderModal: '',

    // 移除库存记录ID集合
    RemoveTipsActive: false,
    removeIds: [],
    removeActionLoading: false
  };

  //进入页面调用接口
  componentDidMount() {
    this.getPageData();
    if(AppBridge && AppBridge.exist()) {
      AppBridge.setTitleBar('Private storage','/admin/customService')
    }
  }

  // 创建订单请求成功，刷新一下列表页面
  requestCreateSuccessCallBack = () => {
    this.getPageData(true);
  }


  toggleToast = (showToastText, showToastIserror=false) => {
    this.setState(({ showToast }) => ({
      showToast: !showToast,
      showToastText: showToastText,
      showToastIserror: showToastIserror
    }));
  };
  handleFiltersQueryChangeDebounce = _.debounce(() =>{
    this.getPageData(true);
  },500)
  // 获取列表数据
  getPageData = async(isSearch=false) =>{
    if(isSearch){
      this.setState({
        isSearching: true,
        hasPrevious : false,
        hasNext : false,
      });
    }else{
      this.setState({
        loadingPage: true,
        hasPrevious : false,
        hasNext : false,
      });
    }
    // 筛选库存数量
    let filterParam = '';
    if(this.state.filterIsSearch){
      filterParam = {
        selected: this.state.expressionSelect,
        value: this.state.filterValue
      }
    }

    const params = {
      q: this.state.queryValue,
      page: this.state.page,
      size: this.state.size,
      type: (this.state.tabSelected === 0) ? 3 : 2,
      sort: this.state.sortBy,
      filter: filterParam,
    };
    const response = await reqGetInventoryList(params);
    if(response.code==='200'){
      let getData = response.data;
      this.setState({
        loadingPage: false,
        pageData: getData.result,
        total: getData.count,
        ShowCountNumber: getData.count,
        isSearching: false,
      });

      // 更新分页数据
      if(this.state.page > 1){
        this.setState({
          hasPrevious:true
        });
      }else{
        this.setState({
          hasPrevious:false
        });
      }

      const maxPage =  Math.ceil(response.data.count / this.state.size);
      if(this.state.page < maxPage){
        this.setState({
          hasNext:true
        });
      }else{
        this.setState({
          hasNext:false
        });
      }

    }else{
      this.toggleToast(response.msg);
      this.setState({
        loadingPage: false,
        pageData: [],
        isSearching: false,
      });
    }
  }

  // tabs 切换
  handleTabChange = (index) =>{
    this.setState({
      tabSelected: index,
      selectedResources: [],
      filterValue: '',
      filterIsSearch: false,
    },()=>{
      this.handleFiltersQueryChangeDebounce()
    });
  }

  // filter 筛选选项选择
  handleFilterStatusChange = (status) =>{
    this.setState({
      filterStatus: status,
    });
  }

  // 筛选变化
  handleFilterValueChange = (value,field) =>{
    this.setState({
      [field]: value,
    });
  }

  // filter 筛选确认搜索
  handleFilterSearch =()=>{
    this.setState({
      filterIsSearch: true,
    },()=>{
      this.handleFiltersQueryChangeDebounce()
    });
  }

  // filter 筛选选项移除
  handleFilterStatusRemove = () =>{
    this.setState({
      selectedResources: [],
      filterValue: '',
      filterIsSearch: false,
      page: 1,
    },()=>{
      this.handleFiltersQueryChangeDebounce()
    });
  }

  // filter 清除所有选项选择
  handleFiltersClearAll = () =>{
    this.setState({
      queryValue: '',
      selectedResources: [],
      filterValue: '',
      filterIsSearch: false,
      page: 1,
    },()=>{
      this.handleFiltersQueryChangeDebounce()
    });
  }

  // 搜索输入
  handleFiltersQueryChange = (value) =>{
    this.setState({
      queryValue: value,
      selectedResources: [],
      page: 1,
    },()=>{
      this.handleFiltersQueryChangeDebounce()
    });
  }

  // 清空搜索内容
  handleQueryValueRemove =()=>{
    this.setState({
      queryValue: '',
      selectedResources: [],
      page: 1,
    },()=>{
      this.handleFiltersQueryChangeDebounce()
    });
  }

  // select change
  handleSelectChange = (value) =>{
    this.setState({
      sortBy: value,
      selectedResources: [],
      page: 1,
    },()=>{
      this.handleFiltersQueryChangeDebounce()
    })
  }

  
  // [SelectionType] checkbox类型：all (选择所有数据，包括未展示的) / multi (范围选择) / page (全选当前页面数据) / single (单个)
  // [toggleType] 动作：true / false
  // [selection] 当前选中行的vid值
  handleSelectionChange =(SelectionType,toggleType,selection=0)=>{
    let data = this.state.pageData;
    let selectedData = this.state.selectedResources;
    let isCheckedAllMore = false;
    let isAllowSelectAll = false;

    switch(SelectionType) {
      case 'single':
        if (toggleType) {
          selectedData.push(selection);

          // 判断时候已选中当前页面所有数据
          if (this.state.moreDataSwitch) {
            if (selectedData.length === data.length) {
              isAllowSelectAll = true;
            }
          }

        } else {
          let index = selectedData.indexOf(selection); 
          if (index > -1) { 
            selectedData.splice(index, 1); 
          } 
        }

        break;

      case 'page':
        if (!toggleType) {
          // 重置数组
          selectedData.length = 0;

        } else {
          selectedData.length = 0;
          for (let i = 0; i < data.length; i++) {
            selectedData.push(data[i].vid);
          }

          // 判断时候已选中当前页面所有数据
          if (this.state.moreDataSwitch) {
            if (selectedData.length === data.length) {
              isAllowSelectAll = true;
            }
          }
        }
        break;

      case 'multi':
        // 此时 selection 返回的是一个数组 [startKey,endKey]，数组的范围，开始的key和结束的key
        if(selection.length !== undefined){
          for (let i = selection[0]; i <= selection[1]; i++) {
            let inArrayKey = selectedData.indexOf(data[i].vid); 
            if (inArrayKey === -1) {
              selectedData.push(data[i].vid);
            }
          }

          // 判断时候已选中当前页面所有数据
          if (this.state.moreDataSwitch) {
            if (selectedData.length === data.length) {
              isAllowSelectAll = true;
            }
          }
        }
        break;

      case 'all':
        isCheckedAllMore = toggleType;
        if (this.state.moreDataSwitch && toggleType) {
          isAllowSelectAll = true;
        }
        break;

      default:
    }

    this.setState({
      selectedResources: selectedData,
      allResourcesSelected: isCheckedAllMore,
      isAllowSelectAllItems: isAllowSelectAll
    });
  }

 
  // 增加库存下单弹窗
  handleAddInventory = (e,id,type) =>{
    e.stopPropagation();
    let ids = [];
    if (type === 'single') {
      ids.push(id);
    } else {
      ids = this.state.selectedResources
    }

    let content = (
      <AddInventoryModal 
        show={true}
        ids={ids}
        type={(this.state.tabSelected === 0) ? 3 : 2}
      />
    );
    this.setState({
      AddInventoryOrderModal: content
    });
  }

  // 移除库存记录检测
  handleRemoveInventory = () =>{
    let data = this.state.pageData;
    let selectedData = this.state.selectedResources;  // vid集合
    let ids = [];
    if (selectedData.length > 0) {
      for (let i = 0; i < selectedData.length; i++) {
        for (let j = 0; j < data.length; j++) {
          if (selectedData[i] === data[j].vid) {
            // incoming 与 available 都为0 的情况才可以移除
            if((data[j].incoming === 0) && (data[j].available === 0)){
              ids.push(data[j].id);
            }
          }
        }
      }
    }

    this.setState({
      removeIds: ids,
    },()=>{
      // 弹窗提示
      this.handleRemoveTips();
    });
  }

  // 移除记录提示弹窗
  handleRemoveTips = () =>{
    this.setState(({ RemoveTipsActive }) => ({ RemoveTipsActive: !RemoveTipsActive }));
  }

  // 移除库存记录确认
  handleRemoveDone = async() => {
    let ids = this.state.removeIds;
    if (ids.length > 0) {
      this.setState({removeActionLoading: true });
      const params = {
        type: (this.state.tabSelected === 0) ? 3 : 2,
        ids: JSON.stringify(ids),
      };
      const response = await reqPostRemoveInventory(params);
      this.setState({removeActionLoading: false });

      if(response.code==='200'){
        if(response.data > 0){  // 有修改,刷新列表,并取消选择
          this.setState({
            selectedResources: []
          },()=>{
            setTimeout(() => {
              this.getPageData(true);
            }, 600);
          })
        }
        this.toggleToast('Removed successfully');
        this.handleRemoveTips();
      }else{
        this.toggleToast('Removed failed');
      }

    } else {
      this.toggleToast('No variants inventory');
    }
  }
  
  render() {
    const toastMarkup = this.state.showToast ? <Toast content={this.state.showToastText} onDismiss={()=>this.toggleToast('')} error={this.state.showToastIserror} duration={1500} /> : null;
    const {
      isSearching,ShowCountNumber,pageData,allResourcesSelected,selectedResources,isAllowSelectAllItems,AddInventoryOrderModal,RemoveTipsActive,removeIds
    } = this.state;

    const initSkeletonPage = (
      <div>
        <SkeletonPage fullWidth={true}>
        <Layout>
          <Layout.Section>
          <Card>
          <BlockStack gap={400}>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          </BlockStack>
          </Card>
        </Layout.Section>
          </Layout>
        </SkeletonPage>
      </div>
    );

    const RemoveTipsModal = (
      <Modal
        open={RemoveTipsActive}
        onClose={this.handleRemoveTips}
        title={intl.get("Remove variants")}
        primaryAction={{
          content: intl.get('Remove'),
          onAction: this.handleRemoveDone,
          disabled: (removeIds.length > 0) ? false : true,
          loading: this.state.removeActionLoading
        }}
        secondaryActions={[
          {
            content: intl.get('Cancel'),
            onAction: this.handleRemoveTips,
          },
        ]}
      >
        <Modal.Section>
           
            <p>
              {intl.get('Remove {{removeIds}} variants with 0 inventory.',removeIds.length)}
            </p>
           
        </Modal.Section>
      </Modal>
    )

    
    const TabSelectArray = [
      {
        id: "tab-product-inventory",
        content: intl.get("Product"),
        accessibilityLabel: "All product inventory",
      },
      // {
      //   id: "tab-packaging-inventory",
      //   content: intl.get("Packaging"),
      //   accessibilityLabel: "All packaging inventory",
      // },
    ];

    const filters = [
      {
        key: 'filterStatus',
        label: intl.get('Filter'),
        filter: (
          <div>
            <FormLayout>
              <Select
                label={intl.get("Show all inventory where:")}
                options={[intl.get('Inventory quantity')]}
                onChange={this.handleFilterStatusChange}
                value={this.state.filterStatus}
              />
              <Select
                id="expressionSelect"
                label={intl.get("Expression")}
                labelHidden
                options={[intl.get('equal to'),intl.get('not equal to'),intl.get('greater than'),intl.get('less than')]}
                onChange={this.handleFilterValueChange}
                value={this.state.expressionSelect}
              />
              <TextField
                id="filterValue"
                label={intl.get("Quantity")}
                labelHidden
                type="number"
                onChange={this.handleFilterValueChange} 
                value={this.state.filterValue}
              />
              <Button
                onClick={this.handleFilterSearch}
                disabled={(this.state.filterValue !== '') ? false : true}
              >
               {intl.get("Add filter")}
              </Button>
            </FormLayout>
          </div>
        ),
        shortcut: true,
        hideClearButton: true
      },
    ];

    const appliedFilters = [];
    if (!isEmpty(this.state.filterValue) && !isEmpty(this.state.expressionSelect) && this.state.filterIsSearch) {
      const key = 'filterStatus';
      appliedFilters.push({
        key,
        label: disambiguateLabel(key, this.state.filterValue,this.state.expressionSelect,this.state.filterStatus),
        onRemove: this.handleFilterStatusRemove,
      });
    }

    var footerContentMsg ='';
    if(this.state.total > 0){
      const startNum = (((this.state.page - 1) * this.state.size) + 1);
      const endNum   = (this.state.page * this.state.size>this.state.total)?this.state.total:this.state.page * this.state.size;
      footerContentMsg = <div>{intl.get("Showing {{startNum}} - {{endNum}} of {{total}} results", startNum, endNum, this.state.total)}</div>;
    }

    const PaginationSettings = this.state.loadingPage ? '' :
      (ShowCountNumber !== 0) ?
        <div className="Polaris-New-Pagination">
          <Pagination
            label={footerContentMsg}
            hasPrevious = {this.state.hasPrevious}
            onPrevious={() => {
              this.setState(({page:this.state.page - 1}),()=>{
                  this.getPageData(true);
              });
            }}
            hasNext = {this.state.hasNext}
            onNext={() => {
              this.setState(({page:this.state.page + 1}),()=>{
                  this.getPageData(true);
              });
            }}
          />
        </div> : '';

    // 单复数 显示设置
    const resourceName = (this.state.tabSelected === 0) ? (
      {
        singular: intl.get('product'),
        plural: 'products',
      }
    ) : (
      {
        singular: intl.get('packaging'),
        plural: 'packagings',
      }
    );

    // 批量操作
    const promotedBulkActions = [
      // {
      //   content: intl.get('Update quantity'),
      //   onAction: (e) => this.handleAddInventory(e,0,'batch'),
      // },
      {
        content: intl.get('Remove'),
        onAction: this.handleRemoveInventory,
      },
    ];
    // 批量操作 more actions 数组
    const bulkActions = [
      // {
      //   content: 'Add tags',
      //   onAction: () => console.log('Todo: implement bulk add tags'),
      // },
    ];

    const sortOptions = [
      {label: intl.get('Available (ascending)'), value: 'available_asc'},
      {label: intl.get('Available (descending)'), value: 'available_desc'},
      {label: intl.get('Incoming (ascending)'), value: 'incoming_asc'},
      {label: intl.get('Incoming (descending)'), value: 'incoming_desc'},
    ];
  
    // 列表数据
    const rowMarkup = pageData.map((item, index) => {
        let imageUrl = '/default_image.png';
        if(item.sku_image !== '' && (typeof item.sku_image) !=='object'){
          imageUrl = item.sku_image;
        }

        return (
          <IndexTable.Row
            id={item.vid}
            key={item.vid}
            selected={selectedResources.includes(item.vid)}
            position={index}
          >
            <IndexTable.Cell>
              <Thumbnail source={imageUrl} alt={item.title} />
            </IndexTable.Cell>
            <IndexTable.Cell>
              <div className="Inventory_Product">
                <div className="Inventory_Product__Title">{item.title}</div>
                <div className="Inventory_Variant_Title">{item.variant_title}</div>
              </div>
            </IndexTable.Cell>
            <IndexTable.Cell>{item.sku}</IndexTable.Cell>
            <IndexTable.Cell>{item.incoming}</IndexTable.Cell>
            <IndexTable.Cell>
              <div className={(item.available === 0) ? 'No_Available': ''}>
                {item.available}
              </div>
            </IndexTable.Cell>
            <IndexTable.Cell>
              <div className="Inventory_Action">
              <Tooltip content="TCurrently not supported.">
              <Button
              disabled={true}
              onClick={(e)=>this.handleAddInventory(e,item.vid,'single')}
              variant='primary'
              >
              {intl.get("Add")}
              </Button>
            </Tooltip>
              </div>
            </IndexTable.Cell>
          </IndexTable.Row>
        )
      },
    );

    const pageContent = this.state.loadingPage ? initSkeletonPage : (
      <section>
        <Page 
          title={AppBridge.exist() ? "" : <div style={{fontSize:'20px'}} >{intl.get('Private storage')}</div>}
          backAction={AppBridge.exist() ? undefined : {content: 'Braning', onAction: () =>{
            utils.routeListen('/admin/customService')
            utils.routeJump(this,'/admin/customService')
            }}}
          fullWidth 
        >
          <Layout>
            <Layout.Section>
              <Card>
                <Tabs
                  tabs={TabSelectArray}
                  selected={this.state.tabSelected}
                  onSelect={this.handleTabChange}
                >
                 
                  <div style={{padding: '0 0 16px 0', display: 'flex'}}>
                    <div style={{flex: 1}}>
                      <Filters
                        queryValue={this.state.queryValue}
                        queryPlaceholder={intl.get('Search inventory')}
                        filters={filters}
                        appliedFilters={appliedFilters}
                        onQueryChange={this.handleFiltersQueryChange}
                        onQueryClear={this.handleQueryValueRemove}
                        onClearAll={this.handleFiltersClearAll}
                      />
                    </div>
                    <div style={{padding: '6px 0 0 4px'}}>
                      <Select
                        labelInline
                        label={intl.get("Sort by")}
                        options={sortOptions}
                        value={this.state.sortBy}
                        onChange={this.handleSelectChange}
                      />
                    </div>
                  </div>

                  <div style={{minHeight:'800px'}}>
                    <IndexTable
                      resourceName={resourceName}
                      itemCount={pageData.length}
                      selectedItemsCount={
                        allResourcesSelected ? intl.get('All') : selectedResources.length
                      }
                      onSelectionChange={this.handleSelectionChange}
                      hasMoreItems={isAllowSelectAllItems}
                      bulkActions={bulkActions}
                      promotedBulkActions={promotedBulkActions}
                      loading={isSearching}
                      headings={[
                        {title: ''},
                        {title: intl.get('Product')},
                        {title: intl.get('SKU')},
                        {title: intl.get('Incoming')},
                        {title: intl.get('Available')},
                        {title: intl.get('Action')},
                      ]}
                    >
                      {rowMarkup}
                    </IndexTable>
                  </div>

                </Tabs>
              </Card>

              <div className="space"></div>

              {/* 分页 */}
              {PaginationSettings}

            </Layout.Section>
          </Layout>
        </Page>
      </section>
    )

    return (
      <div>
        {/* 页面内容 */}
        {pageContent}
        {/* 增加库存弹窗 */}
        {AddInventoryOrderModal}
        {/* 移除库存记录提示弹窗 */}
        {RemoveTipsModal}

        {toastMarkup}
      </div>
    );

    function disambiguateLabel(key, value,expression='',filterItem='') {
      switch (key) {
        case 'taggedWith':
          return `Tagged with ${value}`;
        case 'filterStatus':
          return `${filterItem +' ' + expression + ' ' + value}`;
          // return value.map((val) => `${val}`).join(' , ');
        default:
          return value;
      }
    }

    function isEmpty(value) {
      if (Array.isArray(value)) {
        return value.length === 0;
      } else {
        return value === '' || value == null;
      }
    }
    
  }
}

export default CustomPackagingClass;
